import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import { utils } from './utils.js';

import './assets/css/tailwind.css';

import './assets/css/theme.scss';

Vue.config.productionTip = false;

Vue.prototype.$utils = utils;

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
